import { render, staticRenderFns } from "./DeleteSection.vue?vue&type=template&id=0c0d6ea6&scoped=true"
import script from "./DeleteSection.vue?vue&type=script&lang=js"
export * from "./DeleteSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c0d6ea6",
  null
  
)

export default component.exports